import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import AdvantagesModal from "QuotePage/app/AdvantagesModal";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { isPartner } from "Utils/isPartner";

import { Collapse } from "Cobalt/Collapse";
import { TitleSmall } from "Cobalt/Header";
import { ReduxTriggerButton } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import { Card } from "Common/Card";
import EnterAgesTable from "Common/EnterAges/Components/EnterAgesTable";
import EnterAgesTableBackgroundPlaceholder from "Common/EnterAges/Components/EnterAgesTableBackgroundPlaceholder";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "enter_ages_component";
const bem = makeBem("EnterAgesComponent");
export class EnterAgesComponentDumb extends React.Component {
  static defaultProps = {
    startOpen: true,
  };

  constructor(props) {
    super();
    this.state = {
      modifiedAges: false,
      isOpen: props.startOpen,
      showingAdvantages: false,
    };
    this.hideAdvantages = this.hideAdvantages.bind(this);
  }

  toggle = () => {
    AnalyticsTracking.trackEvent(this.state.isOpen ? "edit_ages_collapse" : "edit_ages_expand", {
      location: ANALYTICS_LOCATION,
    });
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  renderToggleIcon() {
    return (
      <div className={bem("ShowText")}>
        <BodyText componentClass="span">{this.state.isOpen ? "Show Less" : "Show More"}</BodyText>
        <Icon icon={this.state.isOpen ? "angle-up" : "angle-down"} size="normal" className={bem("Carat")} mx={4} />
      </div>
    );
  }

  showAdvantages() {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "compact_quote_page",
      feature: "advantages_modal",
    });
    this.setState({
      showingAdvantages: true,
    });
  }

  hideAdvantages() {
    this.setState({
      showingAdvantages: false,
    });
  }

  render() {
    const { employeeProfile, openModal, isLoading } = this.props;
    const maxEmployeesDisplayed = 3;
    let toggleText;

    if (isPartner()) {
      toggleText = `Employees Synced from Payroll`;
    } else {
      toggleText = "Enter Employee Ages To See An Exact Quote";
    }

    return isLoading ? (
      <BodyText>
        <Div mb={4}>Loading your employees' ages...</Div>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Icon icon="spinner" spin="pulse" size="2x" mb={4} />
        </div>
      </BodyText>
    ) : (
      <div>
        <BodyText
          className={classnames(bem("HeaderRow"), {
            [bem("HeaderRow", "open")]: this.state.isOpen,
          })}
          py={isIntuit() ? 2 : 3}
          mb={0}
          onClick={this.toggle}
        >
          <TitleSmall mt={0} mb={0}>
            {toggleText}
          </TitleSmall>
          {this.renderToggleIcon()}
        </BodyText>
        <Collapse in={this.state.isOpen}>
          <Div
            className={classnames(bem("CollapsingRow"), {
              [bem("CollapsingRow", "intuit")]: isIntuit(),
            })}
            mb={5}
          >
            <Card theme="flat">
              {/* Hacky workaround to some nasty value issues with React Final Form and multiple forms/values causing render bug */}
              {openModal ? <EnterAgesTableBackgroundPlaceholder limit={maxEmployeesDisplayed} /> : <EnterAgesTable limit={maxEmployeesDisplayed} />}
              <ReduxTriggerButton name="enterAgesModal" p={0}>
                {employeeProfile.length > 3 ? "Add/Edit Employees" : "Add Additional Employees"}
              </ReduxTriggerButton>
            </Card>
          </Div>
        </Collapse>
        <AdvantagesModal show={this.state.showingAdvantages} onHide={this.hideAdvantages} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  employeeProfile: state.employeeProfile,
  openModal: state.openModal,
});

export default connect(mapStateToProps)(EnterAgesComponentDumb);
